export default "__VITE_ASSET__h6jEsu9F__"